import React, { useEffect } from 'react'
// import { initialerror } from '../Data/PersonStaticDetails'
// import Genreperson from '../Movie/genreperson'
// import AwardsPoliticalAlmamater from './awardsalmamaterpolitical'
import Validation from './CreatePersonValidation'
// import CurrentlyActive from './CurrentlyActive'
// import DieD from './DieD'
import Dob from './Dob'
// import Nationality from './Nationality'
// import Occupation from './Occupation'
import PersonPoster from './personposter'
import PlaceofBirth from './PlaceofBirth'
import Wikipedia from './Wikipedia'
// import AwardspoliticsAlmamater from './Awardspoliticsalmamater'
// import PersonSuggestComponents from './PersonSuggestComponents'
// import GalleryVideos from '../Movie/GalleryVideos'
// import GalleryImages from '../Movie/GalleryImages'
import PopularPersonNameFieldBioPopularlyKnownas from './PopularPersonNameFieldBioPopularlyKnownas'
// import ExtendedpersonsInfo from './Extendedpersons'
// import MovieReviewComponent from '../Movie/MovieReviewComponent'
import TfidbTags from '../Movie/TfidbTags'
import AdminTfidbTags from '../Movie/AdminTags'
// import VideoGallery from '../Movie/GalleryVideos/VideoGallery'
import TextAreaWithLink from './PersonTOC/TextAreaWithLink'

const Personuicomponent = props => {
  // props for this file
  const {
    PersoninputData,
    rendeedPersondata,
    valueChanged,
    sendValuechangedBoolean,
    sendInputdata,
    updateInputData,
    Edit,
    MultiplePersons,
    disableInput,
    // setLoadPopup,
    personName,
    setpersonName,
    personNamete,
    setpersonNamete,
    shortBio,
    setShortbio,
    shortBiote,
    setShortbiote,
    wikipediaURL,
    setWikipediaURL,
    error,
    setError,
    // personNationality,
    setNationality,
    // personDied,
    setpersonDied,
    // PersonCurrentlyActive,
    setPersonCurrentlyActive,
    SubmitPerson,
  } = props

  // function for handling change of name english
  const handleNameChange = e => {
    sendValuechangedBoolean('name', true)
    setpersonName(e.target.value)
  }

  // function for handling change of name telugu
  const handleNameteChange = e => {
    sendValuechangedBoolean('namete', true)
    setpersonNamete(e.target.value)
  }

  // function for handling change of shotbio Telugu
  const handleWikipediaURLChange = e => {
    sendValuechangedBoolean('wiki', true)
    setWikipediaURL(e.target.value)
  }

  // function for handling change of nationality
  // const handleNationalityChange = e => {
  //   sendValuechangedBoolean('nationality', true)
  //   setNationality(e.target.value)
  // }

  // function for handling person dead or alive
  // const handleDiedChange = e => {
  //   sendValuechangedBoolean('died', true)
  //   if (e.target.value !== '') {
  //     setPersonCurrentlyActive('false')
  //   }

  //   setpersonDied(e.target.value)
  // }

  // function for handling whether a person is active or not
  // const handleActiveChange = e => {
  //   sendValuechangedBoolean('active', true)
  //   setPersonCurrentlyActive(e.target.value)
  // }

  const handleTextAreaChange = newValue => {
    const updatedInfo = { ...PersoninputData }
    updatedInfo.Almamater_En = newValue[0]
    updatedInfo.Almamater_Te = newValue[1]
    sendInputdata(updatedInfo)
    sendValuechangedBoolean('Almamater_En', true)
  }

  const disableButton =
    Object.values(valueChanged).some(e => e === true) &&
    personName &&
    personNamete &&
    PersoninputData.personPoster &&
    shortBio.length > 3 &&
    shortBiote.length > 3 &&
    PersoninputData.occupation.length >= 1 &&
    wikipediaURL.length >= 5

  // function to disable and enable createandupdate button
  const upadateandCreateButtondisable = () => disableButton

  // useEffect for name,bio,wikipedia validations
  useEffect(() => {
    const validationInput = {
      personName,
      personNamete,
      shortBio,
      shortBiote,
      wikipediaURL,
    }
    const errorArray = Validation(validationInput)
    setError(errorArray)
  }, [personName, personNamete, shortBiote, shortBio, wikipediaURL])

  // useEffect for rendeing personName,personNamete,nationality,died,shotbio,shotbiote,currentlyactive,wikipediaurl
  useEffect(() => {
    if (rendeedPersondata) {
      setpersonNamete(rendeedPersondata.name_Te ? rendeedPersondata.name_Te : '')
      setpersonName(rendeedPersondata.name_En ? rendeedPersondata.name_En : '')
      setNationality(rendeedPersondata.nationality ? rendeedPersondata.nationality : '')
      setpersonDied(rendeedPersondata.died ? rendeedPersondata.died : '')
      setShortbio(rendeedPersondata.about_En ? rendeedPersondata.about_En : '')
      setShortbiote(rendeedPersondata.about_Te ? rendeedPersondata.about_Te : '')
      setPersonCurrentlyActive(
        rendeedPersondata.currentlyActive ? rendeedPersondata.currentlyActive : '',
      )
      setWikipediaURL(rendeedPersondata.personWikiURL ? rendeedPersondata.personWikiURL : '')
    }
  }, [rendeedPersondata])
  return (
    <>
      <form style={{ width: '100%' }}>
        <div>
          <div>
            <PopularPersonNameFieldBioPopularlyKnownas
              PersoninputData={PersoninputData}
              sendInputdata={sendInputdata}
              sendValuechangedBoolean={sendValuechangedBoolean}
              disableInput={disableInput}
              personName={personName}
              personNamete={personNamete}
              error={error}
              handleNameChange={handleNameChange}
              handleNameteChange={handleNameteChange}
              shortBio={shortBio}
              shortBiote={shortBiote}
              setShortbio={setShortbio}
              setShortbiote={setShortbiote}
            />
            {/* <PersonSuggestComponents
              disableInput={disableInput}
              sendInputdata={sendInputdata}
              valueChanged={valueChanged}
              sendValuechangedBoolean={sendValuechangedBoolean}
              PersoninputData={PersoninputData}
            /> */}
            {Edit && <TfidbTags movieData={rendeedPersondata} type={'person'} />}
            {Edit && (
              <AdminTfidbTags movieData={rendeedPersondata} label={'Good'} type={'person'} />
            )}
            {Edit && <AdminTfidbTags movieData={rendeedPersondata} label={'Bad'} type={'person'} />}
            {/* {Edit && (
              <ExtendedpersonsInfo
                PersoninputData={PersoninputData}
                sendInputdata={sendInputdata}
                disableInput={disableInput}
                rendeedPersondata={rendeedPersondata}
              />
            )} */}
            {/* <AwardspoliticsAlmamater
              disableInput={disableInput}
              sendinputdata={sendInputdata}
              truevalue={valueChanged}
              sendValuechangedBoolean={sendValuechangedBoolean}
              name={'Awards'}
              inputField1={'AwardWins_En'}
              inputField2={'AwardWins_Te'}
              inputData={PersoninputData}
            /> */}
           <TextAreaWithLink
          //   key={index}
          type={'basic'}
          labels={['Almamater_En', 'Almamater_Te']}
          placeholders={['Enter almamater in english', 'Enter Almamater in Telugu']}
          value={[PersoninputData.Almamater_En || '', PersoninputData.Almamater_Te || '']}
          onChange={newValue => handleTextAreaChange(newValue)}
          setChangesMade={sendValuechangedBoolean}
        />
            {/* <AwardspoliticsAlmamater
              disableInput={disableInput}
              sendinputdata={sendInputdata}
              truevalue={valueChanged}
              sendValuechangedBoolean={sendValuechangedBoolean}
              name={'PoliticalParty'}
              inputField1={'PoliticalParty_En'}
              inputField2={'PoliticalParty_Te'}
              inputData={PersoninputData}
            /> */}
            <PlaceofBirth
              disableInput={disableInput}
              truevalue={valueChanged}
              sendValuechangedBoolean={sendValuechangedBoolean}
              inputData={PersoninputData}
              sendinputdata={sendInputdata}
            />
            {/* <Genreperson
              disableInput={disableInput}
              inputData={PersoninputData}
              genReTelugu={PersoninputData.genReTelugu}
              truevalue={valueChanged}
              sendValuechangedBoolean={sendValuechangedBoolean}
              genRe={PersoninputData.genRe}
              sendinputdata={sendInputdata}
            /> */}
            {/* <MovieReviewComponent
              MovieYouSayReviewUrl={PersoninputData.yousayPersonReviewURL_En}
              MovieYouSayReviewUrlTe={PersoninputData.yousayPersonReviewURL_Te}
              sendBooleanValueChangeDone={sendValuechangedBoolean}
              sendYousayRating={updateInputData}
              movieReviewArticleTitleEn={PersoninputData.personArticleReviewTitle_En}
              movieReviewArticleTitleTe={PersoninputData.personArticleReviewTitle_Te}
              type={'person'}
            /> */}
            {/* <Occupation
              disableInput={disableInput}
              truevalue={valueChanged}
              sendValuechangedBoolean={sendValuechangedBoolean}
              inputData={PersoninputData}
              sendinputdata={sendInputdata}
              occupation={PersoninputData.occupation}
            /> */}
            {/* <AwardspoliticsAlmamater
              disableInput={disableInput}
              sendinputdata={sendInputdata}
              truevalue={valueChanged}
              sendValuechangedBoolean={sendValuechangedBoolean}
              name={'Roles'}
              inputField1={'Roles_En'}
              inputField2={'Roles_Te'}
              inputData={PersoninputData}
            /> */}
            <Wikipedia
              disableInput={disableInput}
              wikipediaURL={wikipediaURL}
              error={error}
              handleWikipediaURLChange={handleWikipediaURLChange}
            />
            <Dob
              disableInput={disableInput}
              truevalue={valueChanged}
              inputData={PersoninputData}
              sendtruevalue={sendValuechangedBoolean}
              sendinputdata={sendInputdata}
              sendDob={(fieldname, fieldvalue) => updateInputData(fieldname, fieldvalue)}
            />
            {/* <Nationality
              disableInput={disableInput}
              PersonNationality={personNationality}
              handleNationalityChange={handleNationalityChange}
            />
            <CurrentlyActive
              PersonCurrentlyActive={PersonCurrentlyActive}
              handleActiveChange={handleActiveChange}
            />
            <DieD
              disableInput={disableInput}
              personDied={personDied}
              handleDiedChange={handleDiedChange}
            /> */}
            <div>
              <PersonPoster
                disableInput={disableInput}
                personPoster={PersoninputData.personPoster}
                truevalue={valueChanged}
                sendtruevalue={sendValuechangedBoolean}
                sendposterurl={(fieldname, fieldvalue) => updateInputData(fieldname, fieldvalue)}
              />
              {/* <GalleryImages
                disableInput={disableInput}
                inputData={PersoninputData}
                galleryType={'person'}
                ImageType={'person'}
                GalleryImages={PersoninputData.GalleryImages}
                sendinputdata={sendInputdata}
                sendBooleanValueChangeDone={sendValuechangedBoolean}
              />
              <VideoGallery
                disableInput={disableInput}
                inputData={PersoninputData}
                GalleryVideos={PersoninputData.GalleryVideos ? PersoninputData.GalleryVideos : []}
                sendinputdata={sendInputdata}
                sendBooleanValueChangeDone={sendValuechangedBoolean}
              /> */}
            </div>
          </div>
        </div>
        <div className='submitbtn'>
          {MultiplePersons === true ? null : (
            <button
              type='button'
              className='btn btn-primary'
              disabled={!upadateandCreateButtondisable()}
              onClick={() => SubmitPerson()}
            >
              {Edit === 'true' ? 'Update Person' : 'Create Person'}
            </button>
          )}
        </div>
      </form>
    </>
  )
}

export default Personuicomponent
